// import methods from './methods'
import axios from 'axios'
import router from '../router'
import { Notification, Message } from 'element-ui'
import Qs from 'qs'
const ajax = axios.create({
    // baseURL: base,
    // baseURL: config.base,
    timeout: 60000,
    transformRequest: [function (data) {
        if (data && data.constructor !== FormData) {
            return Qs.stringify(data)
        } else {
            return data
        }
    }],
    // withCredentials: true
    // credentials: false
})

// 添加请求拦截器
ajax.interceptors.request.use(config => {
    let token = localStorage.getItem('token')
    if (token) {
        config.headers['Token'] = token
    }
    return config
}, error => {
    console.warn('请求拦截器：请求错误', error)
    return Promise.reject(error);
})


// 添加响应拦截器
ajax.interceptors.response.use(res => {
    if (res.data != "error") {
        return res.data
    } else {
        Message.error(res.data);
    }
    console.warn(res, '响应拦截器：服务端错误')
    return Promise.reject(res)
}, error => {
    console.warn('响应拦截器：本地网络错误，或服务器无响应', error)
    Message.error(error.message);
    return Promise.reject({
        data: {
            err: 500,
            data: null,
            msg: `${error.name ? error.name + ':' : ''}${error.message}`
        }
    })
})

export default function (config) {
    // 返回封装后的 ajax 对象
    config.url = getApiUrl(config)
    return ajax({
        ...config,
    })
}

function getApiUrl({ url }) {
    let first = url.substring(0, 1);
    // let url2 = base.slice(0, routerIndex);
    let url2 = "http://47.94.243.146:8081";
    // let url2 = "http://192.168.2.175:22222";
    return first == '/' ? url2 + url : url2 + '/' + url
}


// WEBPACK FOOTER //
// ./src/lib/ajax.js